import { Link } from "react-router-dom";
import { FileText, ArrowLeft } from "lucide-react";

export default function Termini() {
    return (
        <div className="min-h-screen bg-bone text-stone-700" data-testid="termini-page">
            <header className="border-b border-soft bg-white">
                <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
                    <Link to="/" className="inline-flex items-center gap-2 text-forest hover:opacity-80">
                        <ArrowLeft size={18} /> <span className="font-semibold">Torna al sito</span>
                    </Link>
                    <div className="inline-flex items-center gap-2 text-forest-dark">
                        <FileText size={18} />
                        <span className="font-display font-semibold">Termini e Condizioni</span>
                    </div>
                </div>
            </header>

            <main className="max-w-3xl mx-auto px-6 py-10">
                <h1 className="font-display text-3xl text-forest-dark mb-2">Termini e Condizioni di servizio</h1>
                <p className="text-sm text-stone-500 mb-8">Ultimo aggiornamento: 3 giugno 2026</p>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">1. Oggetto del servizio</h2>
                <p>
                    HACCP Manager è un servizio software-as-a-service (SaaS) che fornisce strumenti di
                    autocontrollo HACCP, contabilità di base e gestione documentale per attività alimentari
                    (ristoranti, pasticcerie, macellerie, alimentari, gastronomie, ortofrutta).
                </p>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">2. Registrazione</h2>
                <ul className="list-disc pl-6 space-y-1">
                    <li>Per utilizzare il servizio è necessario creare un account con email valida e password.</li>
                    <li>L&apos;utente garantisce la veridicità dei dati forniti.</li>
                    <li>L&apos;utente è responsabile della custodia delle credenziali di accesso.</li>
                </ul>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">3. Periodo di prova e abbonamento</h2>
                <ul className="list-disc pl-6 space-y-1">
                    <li>HACCP Manager offre <b>7 giorni di prova gratuita</b> a partire dalla registrazione.</li>
                    <li>Al termine della prova, l&apos;accesso continuato richiede l&apos;attivazione di un abbonamento mensile a <b>9,99€ IVA inclusa</b>, rinnovabile automaticamente.</li>
                    <li>Il pagamento avviene tramite Stripe.</li>
                    <li>L&apos;abbonamento può essere annullato in qualsiasi momento dall&apos;area &quot;Abbonamento&quot; dell&apos;app. La cancellazione ha effetto al termine del periodo di fatturazione corrente.</li>
                </ul>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">4. Diritto di recesso</h2>
                <p>
                    Ai sensi degli artt. 52 e ss. del Codice del Consumo (D.Lgs. 206/2005), il consumatore ha diritto
                    di recedere dal contratto entro 14 giorni dalla sottoscrizione. Trattandosi tuttavia di un
                    contratto B2B (rivolto a titolari di partita IVA), tale diritto può non applicarsi.
                    Per richiedere il rimborso entro 14 giorni dall&apos;attivazione del primo abbonamento, contattare:{" "}
                    <a href="mailto:info@haccpmanger.it" className="text-forest">info@haccpmanger.it</a>
                </p>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">5. Obblighi dell&apos;utente</h2>
                <ul className="list-disc pl-6 space-y-1">
                    <li>Utilizzare il servizio nel rispetto della legge italiana e dell&apos;Unione Europea.</li>
                    <li>Non caricare contenuti illeciti, offensivi o lesivi di diritti di terzi.</li>
                    <li>Non tentare di accedere a dati di altri utenti né compromettere la sicurezza del servizio.</li>
                    <li>Non utilizzare il servizio per attività di reverse engineering, scraping massivo o spam.</li>
                </ul>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">6. Responsabilità HACCP</h2>
                <p>
                    HACCP Manager è uno <b>strumento di supporto</b> per la compilazione dei registri di autocontrollo.
                    La responsabilità legale del rispetto delle norme HACCP (Reg. CE 852/2004, D.Lgs. 193/2007 e
                    successive) ricade sempre sul <b>titolare dell&apos;attività</b>.
                </p>
                <p className="mt-2">
                    L&apos;intelligenza artificiale utilizzata per l&apos;OCR delle fatture e per il riconoscimento vocale
                    può commettere errori. L&apos;utente è sempre tenuto a verificare i dati inseriti prima di
                    presentarli ad autorità sanitarie o fiscali.
                </p>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">7. Disponibilità del servizio</h2>
                <p>
                    HACCP Manager garantisce un&apos;uptime target del 99,5% mensile. Eventuali interruzioni per
                    manutenzione ordinaria saranno comunicate con preavviso. NON sono riconosciuti rimborsi per
                    interruzioni inferiori a 24 ore consecutive.
                </p>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">8. Proprietà intellettuale</h2>
                <p>
                    Tutto il software, marchi, loghi e contenuti grafici di HACCP Manager sono di proprietà
                    esclusiva del titolare. I dati caricati dall&apos;utente (fatture, foto, registrazioni) restano di
                    proprietà dell&apos;utente. L&apos;utente è l&apos;unico proprietario dei propri dati e può esportarli o
                    cancellarli in qualsiasi momento.
                </p>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">9. Limitazione di responsabilità</h2>
                <p>
                    HACCP Manager NON sarà responsabile per:
                </p>
                <ul className="list-disc pl-6 space-y-1">
                    <li>Errori nei dati causati da fotografie illeggibili o registrazioni vocali poco chiare.</li>
                    <li>Sanzioni amministrative ricevute dall&apos;utente da parte di autorità competenti.</li>
                    <li>Perdita di dati causata da forza maggiore (es. catastrofi naturali, cyberattacchi gravi).</li>
                    <li>Danni indiretti, perdita di profitti, perdita di clientela.</li>
                </ul>
                <p className="mt-2">
                    La responsabilità complessiva del Titolare è in ogni caso limitata all&apos;importo dei canoni
                    pagati dall&apos;utente negli ultimi 12 mesi.
                </p>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">10. Modifiche ai termini</h2>
                <p>
                    Eventuali modifiche significative ai presenti Termini saranno notificate all&apos;utente via email
                    con almeno 30 giorni di anticipo. L&apos;utente potrà recedere senza penali entro 30 giorni dalla
                    notifica.
                </p>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">11. Legge applicabile e foro</h2>
                <p>
                    I presenti termini sono regolati dalla legge italiana. Per ogni controversia è competente in
                    via esclusiva il Foro di Genova, salvo applicazione delle norme inderogabili a favore del
                    consumatore.
                </p>

                <h2 className="font-display text-xl text-forest-dark mt-6 mb-3">12. Contatti</h2>
                <p>
                    Email: <a href="mailto:info@haccpmanger.it" className="text-forest">info@haccpmanger.it</a><br />
                    Sito: <a href="https://haccpmanger.it" className="text-forest">haccpmanger.it</a>
                </p>

                <div className="mt-10 pt-6 border-t border-soft text-sm text-stone-500">
                    <Link to="/privacy" className="text-forest font-semibold hover:underline" data-testid="link-privacy">
                        Privacy Policy
                    </Link>
                    {" · "}
                    <Link to="/" className="text-forest font-semibold hover:underline">
                        Torna alla home
                    </Link>
                </div>
            </main>
        </div>
    );
}
